import React from 'react';
import { ISvgIconProps, SvgIcon } from './svg-icon.component';

export const ArrowsRightIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1.1} sizeIsHeight={true} {...props} viewBox="0 0 20 18" ratio={20 / 18}>
            <path
                d="M19.5998 8.4001L11.8373 0.525098C11.4998 0.187598 10.9748 0.187598 10.6373 0.525098C10.2998 0.862598 10.2998 1.3876 10.6373 1.7251L16.9373 8.1376L0.999804 8.1376C0.549805 8.1376 0.174805 8.5126 0.174805 8.9626C0.174805 9.4126 0.549805 9.8251 0.999804 9.8251L17.0123 9.8251L10.6373 16.3126C10.2998 16.6501 10.2998 17.1751 10.6373 17.5126C10.7873 17.6626 11.0123 17.7376 11.2373 17.7376C11.4623 17.7376 11.6873 17.6626 11.8373 17.4751L19.5998 9.6001C19.9373 9.2626 19.9373 8.7376 19.5998 8.4001Z"
                fill={props.color? props.color: "currentColor"}/>

        </SvgIcon>
    );
}
